import React, { useState } from "react";
import { searchBarStyles } from "./style.js";
import { SearchOutlined } from "@ant-design/icons";

const SearchBar = ({ height, width, fontSize }) => {
  const [value, changeValue] = useState("");
  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };

  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };
  return (
    <div style={searchBarStyles.frame}>
      <input
        type="text"
        value={value}
        onInput={(e) => {
          changeValue(e.target.value);
        }}
        onClick={(e) => {
          console.log(document.activeElement);
          console.log(document.hasFocus());
          console.log(window.gapi);
        }}
        style={{ ...searchBarStyles.input, height, width, fontSize }}
      />
      <div
        style={searchBarStyles.searchBtn}
        onMouseOver={highlight}
        onMouseOut={unhighlight}
      >
        <SearchOutlined style={{ ...searchBarStyles.searchIcon, fontSize }} />
      </div>
    </div>
  );
};

export default SearchBar;
